import ertCardRowDirective from './ertCardRow.directive';

const ertCardRowModule = angular.module('app.common.cardRow', [])
	.directive('ertCardRow', ertCardRowDirective)
	.name;

export default ertCardRowModule;
